
import  { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import Modal from 'react-modal';
import useIsMobile from '../../hooks/Helper/useIsMobile';
import { Loader } from '../../components/Loader/Loader';
import logo from '../../assets/success.png';
import { Link, useParams } from 'react-router-dom';
import iconImage from '../../assets/images/user-image.png'; 
import { BlockUI } from '../../components/Loader/BlockUI';
import { useTranslation } from 'react-i18next';
import { getContactId } from '../../tools/utils';
import brownlist from "../../assets/icons/icons8-list-50 (1).png";
import whitelist from "../../assets/icons/icons8-list-50 (2).png";
import browngrid from "../../assets/icons/icons8-grid-50 (1).png";    
import whitegrid from "../../assets/icons/icons8-grid-50 (2).png";
import checkbox from '../../assets/images/icons8-checkbox-48.png'
import check from '../../assets/images/icons8-check-48.png'
import { MyConnectionCard } from '../../components/Cards/MyConnectionCard';
import { useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '../../redux/store';
import { useSelector } from 'react-redux';
import { createCertConnect, editConnection, removeCertWatchRequest, searchContactbyCCOId, setFilterAndFetch } from '../../redux/thunks/certConnectThunks';
import { setConnection, setFilter, setOrderBy, setPage, setPageSize, setSearchContact, setSortBy } from '../../redux/slices/certConnectSlice';
import { CertWatchRequest } from '../../types/certWatch';
import { getActiveDesignations } from '../../redux/thunks/designationThunks';
import { closeModal, openModal, toggleModal} from '../../redux/slices/modalSlice';
import { FaSearch } from 'react-icons/fa';
import ShareModal from '../../components/Common/SocialShare';
import { MyConnectionListView } from '../../components/Cards/MyCoonectionTable';




type ContactSearchForm = {
  CCOId: string;
  OrgId?: string;
};

Modal.setAppElement('#root'); // Make sure #root is your app container ID

export const SearchContact = () => {
  const { register, handleSubmit ,reset} = useForm<ContactSearchForm>();
   const { organizationId } = useParams();
    const contactId = getContactId();

  const isMobile = useIsMobile()


  const { t, i18n } = useTranslation();

  const [appliedDesignations, setAppliedDesignations] = useState<string[]>([]);
  const [viewMode, setViewMode] = useState("grid"); 
    const dispatch = useDispatch<AppDispatch>();
  const { connectionList,connection,filters, loading, 
    error: fetchError,pageSize,totalCount,page,editLoading,searchContact,searchLoading ,searchError,
    requestError,
    requestId,
    requestLoading
  } = useSelector((state: RootState) => state.certConnect);
  const { contactDesignations,activeDesignations, loading: contactDesigLoading,error: contactDesigError } = useSelector((state: RootState) => state.designation);
  const { connectionModal,editCertConnectModal,requestAccessModal,requestSentModal,sortModal,filterModal } = useSelector((state: RootState) => state.modals);

  useEffect(() => {
    dispatch(getActiveDesignations())
   handleGlobalClick(true);
  }, []);


  const onSubmit = (data: ContactSearchForm) => {
    
    dispatch(searchContactbyCCOId({CCOId:data.CCOId,OrgId:organizationId}));

};

const [searchTerm, setSearchTerm] = useState("");

const filterMenuRef = useRef(null);
const [selectedDesignations, setSelectedDesignations] = useState<string[]>([]);
const [designationFilterMode, setDesignationFilterMode] = useState<"any" | "all">("any");
const [availabilityFilter, setAvailabilityFilter] = useState("all");


const handleApplySort = () => {
  handleGlobalClick();
 dispatch(closeModal('sortModal'));
};

  const [designationSearchTerm, setDesignationSearchTerm] = useState("");

  const sortMenuRef = useRef<HTMLDivElement>(null);

  const totalPages = Math.ceil(totalCount / pageSize)

  const handleRemove = async (id: string, contactId: string) => {
    dispatch(removeCertWatchRequest({ Id: id, ContactId: contactId }));
  };

    
    const handleRequestAccess = async () => {
    
    await dispatch(createCertConnect({
        ContactId: searchContact.ContactId,
        OrganizationId: organizationId
      }))

     dispatch(setSearchContact(null));
    dispatch(toggleModal("requestSentModal"));
    reset();
}
  



const [editConnectionForm, setEditConnectionForm] = useState({
  available:false,
  note: '',
});
 //  Define handler before useEffect
const handleClickOutside = (e: MouseEvent) => {
  if (
    filterMenuRef.current &&
    !filterMenuRef.current.contains(e.target as Node)
  ) {
    dispatch(closeModal("filterModal"));
  }

  if (
    sortMenuRef.current &&
    !sortMenuRef.current.contains(e.target as Node)
  ) {
    dispatch(closeModal("sortModal"));
  }
};

//  Attach + detach listener
useEffect(() => {
  document.addEventListener("mousedown", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);

// useEffect(() => {
//   if (connection) {
//     setEditConnectionForm({
//       available: connection.Available,
//       note: connection.Note,
//     });
//   }
// }, [connection]);


  const handleSave = async () => {
    if (!connection) return;
    try {
    await  dispatch(editConnection({
        id: connection.CertWatchRequestId, // adjust to correct identifier
        Available: editConnectionForm.available,
        Note: editConnectionForm.note ??'',
      }));
     
      dispatch(closeModal('editCertConnectModal'));

    } catch (error) {
      console.error(error);
    }
  };





const handleGlobalClick = (isReset: boolean = false) => {
  const baseBody: CertWatchRequest = {
    Id: organizationId,
    PageNumber: isReset ? 1 : page,
    PageSize: isReset ? 25 : pageSize,
    SortBy: filters.SortBy,
    OrderBy: filters.OrderBy,
    Designations: isReset
      ? null
      : selectedDesignations.length > 0
        ? selectedDesignations.join(",")
        : null,
    Availability: isReset
      ? null
      : availabilityFilter === "all"
        ? null
        : availabilityFilter === "available",
    FilterMode: isReset
      ? 0
      : designationFilterMode === "all"
        ? 1
        : 0,
    SearchTerm: isReset ? "" : searchTerm,
  };

  dispatch(setFilterAndFetch(baseBody));
};




  return (
    
    <div style={{ padding: '20px' }}>

<form
  onSubmit={handleSubmit(onSubmit)}
  className='add_connection'
>
  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
    <h2 style={{ margin: 0, fontSize: '16px' }}>{t('MyCCOPro.SearchCandidate.addCandidates')}</h2>
  </div>

  <label style={{ fontSize: '16px' }}></label>


  <div
  style={{
    position: "relative",
    display: "inline-block",
    width: isMobile ? "100%" : "280px",
  }}
>
  <input
  {...register('CCOId', { required: true , setValueAs: (v) => v.trim() })}
    placeholder={t('MyCCOPro.SearchCandidate.enterIdPlaceholder')}
    style={{
      padding: "9px 40px 9px 12px", 
      fontSize: "16px",
      width: "100%",
      border: "2px solid #ccc",
      borderRadius: "15px",
      outline: "none",
      transition: "border-color 0.2s ease",
    }}
    onFocus={(e) => (e.target.style.borderColor = "#c67b05")}
    onBlur={(e) => (e.target.style.borderColor = "#ccc")}
      onKeyDown={(e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // avoid default form submit if you want custom behavior
      handleSubmit(onSubmit)();
    }
  }}
  />

  {/* Search button inside input */}
  <button
type='submit'
    style={{
      position: "absolute",
      top: "50%",
      right: "15px",
      transform: "translateY(-50%)",
      background: "none",
      border: "none",
      cursor: "pointer",
      padding: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <FaSearch style={{ color: "#c67b05", fontSize: "18px" }} />
  </button>
</div>

</form>
{searchLoading && (
  <div style={{ marginTop: '20px' }}>
    <Loader />
  </div>
)}


{!searchLoading && (
  searchError ? (
    <div style={{ marginTop: '20px' }}>
      <p style={{ color: '#c53030', fontSize: '16px', margin: 0 }}>
 {String(
    searchError
      ? typeof searchError === "string"
        ? searchError
        : t(searchError.key as string, searchError.params as any)
      : ""
  )}    </p>
    </div>
  ) : searchContact ? (
(
      <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'left' }}>
        <div
          style={{
            width: '100%',
            maxWidth: '450px',
            padding: '20px',
            borderRadius: '12px',
            backgroundColor: '#ffffff',
            boxShadow: '0 6px 16px rgba(0, 0, 0, 0.1)',
            display: 'flex',
            alignItems: 'flex-start',
            gap: '20px',
          }}
        >
          <img
            src={searchContact.ProfilePicture}
            alt={searchContact.ContactFullName || 'Profile'}
            style={{
              width: '100px',
              height: '100px',
              borderRadius: '12px',
              objectFit: 'cover',
              border: '2px solid #e2e8f0',
            }}
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = iconImage; // fallback icon if broken
            }}
          />

          <div style={{ flex: 1 }}>
            <h3 style={{ margin: 0, fontSize: '20px', fontWeight: '600', color: '#2d3748' }}>
              {searchContact.ContactFullName || 'Name not available'}
            </h3>
            <p style={{ margin: '8px 0', fontSize: '16px', color: '#4a5568' }}>
              <strong>{t('MyCCOPro.CCOID')}</strong> {searchContact.CCOId || 'N/A'}
            </p>

            <button
              onClick={handleRequestAccess}
              disabled={requestLoading}
              style={{
                marginTop: '12px',
                padding: '10px 20px',
                backgroundColor: requestLoading ? '#a0aec0' : '#c67b05',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: requestLoading ? 'not-allowed' : 'pointer',
                fontSize: '15px',
                transition: 'background-color 0.3s ease',
              }}
            >
              {requestLoading
                ? t('MyCCOPro.SearchCandidate.requesting')
                : t('MyCCOPro.SearchCandidate.requestAccess')}
            </button>
          </div>
        </div>
      </div>
    )
  ) : null
)}






{requestSentModal && (
<Modal
     isOpen={true}
  onRequestClose={()=>dispatch(openModal("requestSentModal"))}
      contentLabel="Request Sent Confirmation"
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
        content: {
          width: '400px',
          padding: '20px',
          borderRadius: '10px',
          inset: 'unset',
          backgroundColor: '#fff',
          textAlign: 'center',
          position: 'relative',
        },
      }}
    >
      <button
        onClick={()=>
          dispatch(closeModal("requestSentModal"))}
        style={{
          position: 'absolute',
          top: '10px',
          right: '10px',
          background: 'none',
          border: 'none',
          fontSize: '20px',
          cursor: 'pointer',
        }}
      >
        &times; {/* Close icon */}
      </button>

      <h2 style={{ fontSize: '20px', marginBottom: '20px' }}>{t('MyCCOPro.SearchCandidate.requestSent')}</h2>

      {/* Attractive Icon (Change to the appropriate icon) */}
      <div style={{ marginBottom: '20px' }}>
        <img
          src={logo} // Use your custom logo or icon
          alt="Success Icon"
          style={{ width: '80px', height: '80px' }}
        />
      </div>

      <button
         onClick={()=>

          dispatch(closeModal("requestSentModal"))
        }
        style={{
          padding: '10px 20px',
          fontSize: '16px',
          backgroundColor: '#c67b05',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
        }}
      >
      {t('MyCCOPro.SearchCandidate.ok')}
      </button>
   </Modal>  
)}





  {/* {
  loading ? (
                  <div className="cco_row cco_row_3"style={{ marginTop: '60px' }} >
                    <Loader />
                  </div>
                )  :(items  ||[]).length < 1 ? (
               null
              ) : (   */}
<>
<div style={{ marginTop: '60px' }}>
  <div className="cco_row cco_row_7">
    <div className="cco_col cco_col_6">
      <div className="cco_text cco_text_10">
        <div className="cco_text_inner">
          <h2>
            <strong>{t('MyCCOPro.SearchCandidate.myConnections')}</strong>
          </h2>
        </div>
      </div>
    </div>
  </div>
</div>


<div className="cco_row cco_row_3"  style={{ marginTop: '20px' }}>
<div
  style={{
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    marginBottom: "20px",
  }}
>
  {/* --- ROW 1: Search + View Select --- */}
  <div
    style={{
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      justifyContent: "space-between",
      alignItems: isMobile ? "stretch" : "center",
      gap: "16px",
    }}
  >
    {/* Search Input */}
    <div
      style={{
        position: "relative",
        display: "inline-block",
        width: isMobile ? "100%" : "280px",
      }}
    >
      <input
        type="text"
        placeholder={t("MyCCOPro.SearchCandidate.enterNameOrCCOID")}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            dispatch(setPage(1));
            handleGlobalClick();
          }
        }}
        style={{
          padding: "9px 40px 9px 12px",
          fontSize: "16px",
          width: "100%",
          border: "2px solid #ccc",
          borderRadius: "15px",
          outline: "none",
        }}
      />
      <button
        onClick={() => {
          dispatch(setPage(1));
          handleGlobalClick();
        }}
        style={{
          position: "absolute",
          top: "50%",
          right: "15px",
          transform: "translateY(-50%)",
          background: "none",
          border: "none",
          cursor: "pointer",
          padding: 0,
        }}
      >
        <FaSearch style={{ color: "#c67b05", fontSize: "18px" }} />
      </button>
    </div>

    {/* View Mode Selector (desktop only) */}
    {!isMobile && (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <span style={{ fontSize: "14px", fontWeight: "600" }}>
                {t("MyCCOPro.SearchCandidate.selectView")}

        </span>
        <div style={{ display: "flex", gap: "6px" }}>
          <button
            onClick={() => setViewMode("grid")}
            style={{
              border: "1px solid #ccc",
              borderRadius: "6px",
              // padding: "8px 8px",
              backgroundColor:
                viewMode === "grid" ? "#fef6e6" : "transparent",
              cursor: "pointer",
            }}
          >
            <img
              src={viewMode === "grid" ? browngrid : whitegrid}
              alt="Grid"
              style={{ width: "20px", height: "20px",marginTop:"5px" }}
            />
          </button>
          <button
            onClick={() => setViewMode("list")}
            style={{
              border: "1px solid #ccc",
              borderRadius: "6px",
              // padding: "4px 8px",
              backgroundColor:
                viewMode === "list" ? "#fef6e6" : "transparent",
              cursor: "pointer",
            }}
          >
            <img
              src={viewMode === "list" ? brownlist : whitelist}
              alt="List"
             style={{ width: "20px", height: "20px",marginTop:"5px" }}
            />
          </button>
        </div>
      </div>
    )}
  </div>

  {/* --- ROW 2: Filter/Sort and Summary --- */}
  <div
    style={{
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      justifyContent: "space-between",
      alignItems: isMobile ? "stretch" : "center",
      gap: "12px",
    }}
  >
    {/* Left side: Applied filters summary */}
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: "6px",
      }}
    >
     <div
  style={{
    display: "flex",
    flexWrap: "wrap",
    gap: "6px",
    alignItems: "center",
  }}
>
  {/* Designations */}
  <span
    style={{
      fontSize: "12px",
      fontWeight: "600",
      color: "#444",
      marginRight: "4px",
    }}
  >
    {t('MyCCOPro.SearchCandidate.Labels.designation')}
  </span>

{appliedDesignations.length > 0 ? (
  appliedDesignations.map((code) => {
      const designation = activeDesignations.find((d) => d.Code === code);
      return (
        <span
          key={code}
          style={{
            padding: "4px 8px",
            backgroundColor: "#fef6e6",
            color: "#c67b05",
            borderRadius: "4px",
            fontSize: "12px",
            fontWeight: "500",
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            whiteSpace: "nowrap",
          }}
        >
          {designation?.Code || code}
        </span>
      );
    })
  ) : (
    <span
      style={{
        padding: "4px 8px",
        backgroundColor: "#fef6e6",
        color: "#c67b05",
        borderRadius: "4px",
        fontSize: "12px",
        fontWeight: "500",
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        whiteSpace: "nowrap",
      }}
    >
      {t('MyCCOPro.SearchCandidate.Labels.any')}
    </span>
  )}

  {/* Divider */}
  <span style={{ margin: "0 6px", color: "#aaa" }}>|</span>

  {/* Availability */}
  <span
    style={{
      fontSize: "12px",
      fontWeight: "600",
      color: "#444",
      marginRight: "4px",
    }}
  >
      {t('MyCCOPro.SearchCandidate.Labels.availability')}
  </span>
  <span
    style={{
      padding: "4px 8px",
      backgroundColor: "#fef6e6",
      color: "#c67b05",
      borderRadius: "4px",
      fontSize: "12px",
      fontWeight: "500",
      display: "inline-flex",
      alignItems: "center",
      gap: "6px",
      whiteSpace: "nowrap",
    }}
  >
    {/* {availabilityFilter.charAt(0).toUpperCase() + availabilityFilter.slice(1)} */}
    {t(`MyCCOPro.SearchCandidate.filter.availabilityOptions.${availabilityFilter}`)}

  </span>

  
  <span style={{ margin: "0 6px", color: "#aaa" }}>|</span>


  <span
    style={{
      fontSize: "12px",
      fontWeight: "600",
      color: "#444",
      marginRight: "4px",
    }}
  >
    {t('MyCCOPro.SearchCandidate.Labels.matchMode')}
  </span>
  <span
    style={{
      padding: "4px 8px",
      backgroundColor: "#fef6e6",
      color: "#c67b05",
      borderRadius: "4px",
      fontSize: "12px",
      fontWeight: "500",
      display: "inline-flex",
      alignItems: "center",
      gap: "6px",
      whiteSpace: "nowrap",
    }}
  >
      {designationFilterMode === "all" ? t('MyCCOPro.SearchCandidate.Labels.all') : t('MyCCOPro.SearchCandidate.Labels.any')}
  </span>
    <span style={{ margin: "0 6px", color: "#aaa" }}>|</span>
  <span
    style={{
      fontSize: "12px",
      fontWeight: "600",
      color: "#444",
      marginRight: "4px",
    }}
  >
    {t('MyCCOPro.SearchCandidate.Labels.sortBy')}
  </span>
  <span
    style={{
      padding: "4px 8px",
      backgroundColor: "#fef6e6",
      color: "#c67b05",
      borderRadius: "4px",
      fontSize: "12px",
      fontWeight: "500",
      display: "inline-flex",
      alignItems: "center",
      gap: "6px",
      whiteSpace: "nowrap",
    }}
  >
     {filters.SortBy == 0 ? t('MyCCOPro.SearchCandidate.name') : t('MyCCOPro.SearchCandidate.ccoid')}
  </span>

  <span
    style={{
      padding: "4px 8px",
      backgroundColor: "#fef6e6",
      color: "#c67b05",
      borderRadius: "4px",
      fontSize: "12px",
      fontWeight: "500",
      display: "inline-flex",
      alignItems: "center",
      gap: "6px",
      whiteSpace: "nowrap",
    }}
  >
    {filters.OrderBy === 0 ?  t('MyCCOPro.SearchCandidate.Labels.asc') : t('MyCCOPro.SearchCandidate.Labels.desc')}
  </span>

{(selectedDesignations.length > 0 || 
  availabilityFilter !== "all" ||
  designationFilterMode !== "any" ||
  searchTerm !== "") && (
  <button
    onClick={() => {
      setSelectedDesignations([]);
      setAppliedDesignations([]);
      setDesignationFilterMode("any");
      setAvailabilityFilter("all");
      setDesignationSearchTerm("");
      dispatch(setOrderBy(0));
      dispatch(setSortBy(0));
      setSearchTerm("");
      handleGlobalClick(true);
    }}
    style={{
     
      fontSize: isMobile ? "14px" : "14px",
      fontWeight: "600",
      border: "2px solid #c67b05",
      borderRadius: "20px",
      backgroundColor: "white",
      color: "#c67b05",
      cursor: "pointer",
      width: isMobile ? "100%" : "auto",
      minWidth: isMobile ? "0px" : "0px",
      transition: "all 0.2s ease",
    }}
    onMouseEnter={(e) => {
      const target = e.currentTarget;
      target.style.backgroundColor = "#fef6e6";
    }}
    onMouseLeave={(e) => {
      const target = e.currentTarget;
      target.style.backgroundColor = "white";
    }}
  >
    {t("MyCCOPro.SearchCandidate.Labels.reset")}
  </button>
)}

</div>
    </div>


    {/* Right side: Filter/Sort buttons */}
    <div
      style={{
        display: "flex",
        gap: "10px",
        justifyContent: isMobile ? "stretch" : "flex-end",
      }}
    >
       <div style={{ position: "relative", flex: isMobile ? 1 : "none" }}  ref={filterMenuRef} >

      <button
        onClick={() => dispatch(filterModal? closeModal('filterModal') : openModal('filterModal'))}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "6px",
          padding: "6px 14px",
          fontSize: isMobile ? "14px" : "16px",
          fontWeight: "600",
          border: "2px solid #c67b05",
          borderRadius: "20px",
          backgroundColor: "white",
          color: "#c67b05",
          cursor: "pointer",
          width: isMobile ? "100%" : "auto",
          minWidth: isMobile ? "0px" : "100px",
          transition: "all 0.2s ease",
        }}
      >
        {t("MyCCOPro.SearchCandidate.filter.button")}
        <span
          style={{
            display: "inline-block",
            transform: filterModal ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.2s ease",
          }}
        >
          ▼
        </span>
      </button>

      {filterModal && (
        <div
          style={{
            position: isMobile ? "fixed" : "absolute",
            top: isMobile ? "0" : "110%",
            left: isMobile ? "0" : "auto",
            right: isMobile ? "0" : "0",
            bottom: isMobile ? "0" : "auto",
            backgroundColor: "#fafafa",
            border: isMobile ? "none" : "1px solid #e5e5e5",
            borderRadius: isMobile ? "0" : "14px",
            boxShadow: isMobile ? "none" : "0 8px 28px rgba(0,0,0,0.12)",
            padding: "16px",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            zIndex: 1000,
            width: isMobile ? "100%" : "400px",
            maxWidth: isMobile ? "100%" : "none",
            overflowY: "auto",
            maxHeight: isMobile ? "100vh" : "none",
          }}
        >
       
          {isMobile && (
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <button
                onClick={() => dispatch(closeModal('filterModal'))}
                style={{
                  background: "none",
                  border: "none",
                  fontSize: "24px",
                  cursor: "pointer",
                  color: "#666"
                }}
              >
                ×
              </button>
            </div>
          )}
          
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "4px",
            }}
          >
            <span style={{ fontWeight: "600", fontSize: "15px", color: "#333" }}>
              {t("MyCCOPro.SearchCandidate.filter.title")}
            </span>
            <span
              style={{
                fontSize: "13px",
                color: "#c67b05",
                cursor: "pointer",
                fontWeight: "500",
              }}
              onClick={() => {
                setSelectedDesignations([]);
                setDesignationFilterMode("any");
                 setAppliedDesignations([]);
                setAvailabilityFilter("all");
                setDesignationSearchTerm("");
                dispatch(setOrderBy(0));
                dispatch(setSortBy(0));
                setSearchTerm("")
                handleGlobalClick(true);
              }}
            >
              {t("MyCCOPro.SearchCandidate.filter.reset")}
            </span>
          </div>


<div
  style={{
    background: "white",
    border: "1px solid #eee",
    borderRadius: "10px",
    padding: "12px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  }}
>
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
    <div style={{ display: "flex", flexDirection: "column", gap: "8px", flex: 1 }}>
      <label style={{ fontWeight: "600", fontSize: "14px", color: "#333" }}>
        {t("MyCCOPro.SearchCandidate.filter.designations")}
      </label>
      
 
      {selectedDesignations.length > 0 && (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
          {selectedDesignations.map((code) => {
            const designation = activeDesignations.find(d => d.Code === code);
            return (
              <span
                key={code}
                style={{
                  padding: "4px 8px",
                  backgroundColor: "#fef6e6",
                  color: "#c67b05",
                  borderRadius: "0px",
                  fontSize: "12px",
                  fontWeight: "500",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                {designation?.Code || code}
              </span>
            );
          })}
        </div>
      )}
    </div>
    
  </div>
  

  <div style={{ position: "relative" }}>
    <input
      type="text"
      placeholder={t("MyCCOPro.SearchCandidate.searchdesignation")}
      value={designationSearchTerm}
      onChange={(e) => setDesignationSearchTerm(e.target.value)}
      style={{
        padding: "8px 10px 8px 36px",
        fontSize: "14px",
        border: "1px solid #ddd",
        borderRadius: "6px",
        outline: "none",
        width: "100%",
        transition: "border-color 0.2s ease",
      }}
      onFocus={(e) => {
        const target = e.target as HTMLInputElement;
        target.style.borderColor = "#c67b05";
      }}
      onBlur={(e) => {
        const target = e.target as HTMLInputElement;
        target.style.borderColor = "#ddd";
      }}
    />
    <span
      style={{
        position: "absolute",
        left: "10px",
        top: "50%",
        transform: "translateY(-50%)",
        color: "#999",
        fontSize: "14px"
      }}
    >
      🔍
    </span>
  </div>
  
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      gap: "4px",
      maxHeight: "160px",
      overflowY: "auto",
      paddingRight: "4px",
      scrollbarWidth: "thin",
      scrollbarColor: "#c67b05 #f1f1f1",
    }}
  >
  
    <style>
      {`
        div::-webkit-scrollbar {
          width: 6px;
        }
        div::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
        }
        div::-webkit-scrollbar-thumb {
          background: #c67b05;
          border-radius: 10px;
        }
        div::-webkit-scrollbar-thumb:hover {
          background: #a36903;
        }
      `}
    </style>
    
    {activeDesignations
      .filter(d => 
        d.Code.toLowerCase().includes(designationSearchTerm.toLowerCase())
      )
      .map((d) => {
        const isActive = selectedDesignations.includes(d.Code);
        return (
          <label
            key={d.Code}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: "6px 8px",
              borderRadius: "6px",
              cursor: "pointer",
              transition: "all 0.2s ease",
              backgroundColor:"#ffffff !important" ,
              margin: "1px 0",
            }}
            onMouseEnter={(e) => {
              const target = e.currentTarget;
              if (!isActive) {
                target.style.backgroundColor = "#f8f9fa";
              }
            }}
            onMouseLeave={(e) => {
              const target = e.currentTarget;
              if (!isActive) {
                target.style.backgroundColor = "transparent";
              }
            }}
          >
            <div
              style={{
                position: "relative",
                width: "18px",
                height: "18px",
                flexShrink: 0,
              }}
            >
              <input
                type="checkbox"
                checked={isActive}
                onChange={() =>
                  setSelectedDesignations(
                    isActive
                      ? selectedDesignations.filter((c) => c !== d.Code)
                      : [...selectedDesignations, d.Code]
                  )
                }
                style={{
                  position: "absolute",
                  opacity: 0,
                  width: "100%",
                  height: "100%",
                  cursor: "pointer",
                  zIndex: 1,
                }}
              />
              <div
                style={{
                  width: "18px",
                  height: "18px",
                  border: `2px solid ${isActive ? "#c67b05" : "#ddd"}`,
                  borderRadius: "3px",
                  backgroundColor: isActive ? "#c67b05" : "white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "all 0.2s ease",
                }}
              >
                {isActive && (
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.5 4L5.5 10L2.5 7"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap= "round"
                      strokeLinejoin= "round"
                    />
                  </svg>
                )}
              </div>
            </div>
            <span style={{ 
              fontWeight: "600", 
              color: "#333",
              fontSize: "13px"
            }}>
              {d.Code}
            </span>
             <span style={{ 
              color: "#333",
              fontSize: "13px"
            }}>
              {d.Name}
            </span>
          </label>
        );
      })}
  </div>
  
  {activeDesignations.filter(d => 
    d.Code.toLowerCase().includes(designationSearchTerm.toLowerCase()) ||
    d.Code.toLowerCase().includes(designationSearchTerm.toLowerCase())
  ).length === 0 && (
    <div style={{ 
      textAlign: "center", 
      padding: "8px", 
      color: "#999",
      fontSize: "13px"
    }}>
        {t("MyCCOPro.SearchCandidate.nodesignations")}
    </div>
  )}
</div>

          
<div
  style={{
    background: "white",
    border: "1px solid #eee",
    borderRadius: "10px",
    padding: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
  }}
>
  <label style={{ fontWeight: "600", fontSize: "14px", whiteSpace: "nowrap" }}>
    {t("MyCCOPro.SearchCandidate.filter.matchMode") } : 
  </label>

  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
    {/* Toggle */}
    <div
      onClick={() =>
        setDesignationFilterMode(
          designationFilterMode === "any" ? "all" : "any"
        )
      }
      style={{
        width: "70px",
        height: "28px",
        borderRadius: "20px",
        background: designationFilterMode === "all" ? "#c67b05" : "#ccc",
        position: "relative",
        cursor: "pointer",
        transition: "background 0.3s ease",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: "3px",
          left: designationFilterMode === "all" ? "38px" : "4px",
          width: "22px",
          height: "22px",
          borderRadius: "50%",
          background: "white",
          transition: "left 0.3s ease",
        }}
      />
    </div>


    <span style={{ fontSize: "12px", color: "#666", whiteSpace: "nowrap" }}>
      {designationFilterMode === "all"
        ? t("MyCCOPro.SearchCandidate.filter.matchAll")
        : t("MyCCOPro.SearchCandidate.filter.matchAny")}
    </span>
  </div>
</div>


        
          <div
  style={{
    background: "white",
    border: "1px solid #eee",
    borderRadius: "10px",
    padding: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
  }}
>

  <label style={{ fontWeight: "600", fontSize: "14px", whiteSpace: "nowrap" }}>
    {t("MyCCOPro.SearchCandidate.filter.availability")} :
  </label>

 
  <div
    style={{
      display: "flex",
      gap: "10px",
      flexWrap: isMobile ? "wrap" : "nowrap",
      justifyContent: isMobile ? "flex-end" : "unset",
      flex: 1,
    }}
  >
    {[
           { key: "all", label: t("MyCCOPro.SearchCandidate.filter.availabilityOptions.all") },
      { key: "available", label: t("MyCCOPro.SearchCandidate.filter.availabilityOptions.available") },
      { key: "notAvailable", label:  t("MyCCOPro.SearchCandidate.filter.availabilityOptions.notAvailable")},
    ].map((opt) => (
      <div
        key={opt.key}
        onClick={() => setAvailabilityFilter(opt.key)}
        style={{
          padding: "6px 14px",
          borderRadius: "20px",
          fontSize: "13px",
          cursor: "pointer",
          backgroundColor:
            availabilityFilter === opt.key ? "#c67b05" : "#f7f7f7",
          color: availabilityFilter === opt.key ? "white" : "#333",
          fontWeight: availabilityFilter === opt.key ? "600" : "400",
          transition: "all 0.2s ease",
          flex: isMobile ? 1 : "none",
          textAlign: "center",
          minWidth: isMobile ? "80px" : "auto",
        }}
      >
        {opt.label}
      </div>
    ))}
  </div>
</div>

          
          
          <button
            onClick={() =>{
              dispatch(setPage(1))
              handleGlobalClick();
           setAppliedDesignations([...selectedDesignations]);
              dispatch(closeModal("filterModal"));

            }}
            style={{
              padding: "12px",
              backgroundColor: "#c67b05",
              color: "white",
              border: "none",
              borderRadius: "20px",
              fontWeight: "600",
              cursor: "pointer",
              marginTop: "10px"
            }}
          >
              {t("MyCCOPro.SearchCandidate.apply")}
          </button>
        </div>
      )}
    </div>

   <div style={{ position: "relative", flex: isMobile ? 1 : "none" }} ref={sortMenuRef}>
      <button
        onClick={() => dispatch(sortModal? closeModal("sortModal"): openModal("sortModal"))}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "6px",
          padding: "6px 14px",
          fontSize: isMobile ? "14px" : "16px",
          fontWeight: "600",
          border: "2px solid " + (sortModal ? "#a36903" : "#c67b05"),
          borderRadius: "20px",
          backgroundColor: sortModal ? "#a36903" : "#c67b05",
          color: "white",
          cursor: "pointer",
          width: isMobile ? "100%" : "auto",
          minWidth: isMobile ? "0px" : "100px",
          transition: "all 0.2s ease",
        }}
     onMouseEnter={(e) => {
          if (!sortModal) {
            const target = e.currentTarget;
            target.style.backgroundColor = "#a36903";
            target.style.borderColor = "#a36903";
          }
        }}
        onMouseLeave={(e) => {
          if (!sortModal) {
            const target = e.currentTarget;
            target.style.backgroundColor = "#c67b05";
            target.style.borderColor = "#c67b05";
          }
        }}
      >
        {t('MyCCOPro.SearchCandidate.sort')}
        <span
          style={{
            display: "inline-block",
            transform: sortModal ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.2s ease",
          }}
        >
          ▼
        </span>
      </button>
{sortModal && (
  <div
    style={{
      position: isMobile ? "fixed" : "absolute",
      top: isMobile ? "0" : "110%",
      left: isMobile ? "0" : "auto",
      right: isMobile ? "0" : "0",
      bottom: isMobile ? "0" : "auto",
      backgroundColor: "#fafafa",
      border: isMobile ? "none" : "1px solid #e5e5e5",
      borderRadius: isMobile ? "0" : "14px",
      boxShadow: isMobile ? "none" : "0 8px 28px rgba(0,0,0,0.12)",
      padding: "16px",
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      zIndex: 1000,
      width: isMobile ? "100%" : "300px",
      maxWidth: isMobile ? "100%" : "none",
      overflowY: "auto",
      maxHeight: isMobile ? "100vh" : "none",
    }}
  >
    {/* Close button for mobile */}
    {isMobile && (
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <button
          onClick={() => dispatch(closeModal("sortModal"))}
          style={{
            background: "none",
            border: "none",
            fontSize: "24px",
            cursor: "pointer",
            color: "#666"
          }}
        >
          ×
        </button>
      </div>
    )}

    {/* Header with reset */}
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "4px",
      }}
    >
      <span style={{ fontWeight: "600", fontSize: "15px", color: "#333" }}>
        {t("MyCCOPro.SearchCandidate.sort")}
      </span>
      <span
        style={{
          fontSize: "13px",
          color: "#c67b05",
          cursor: "pointer",
          fontWeight: "500",
        }}
        onClick={() => {
          dispatch(setSortBy(0));
          dispatch(setOrderBy(0));
        }}
      >
        {t("MyCCOPro.SearchCandidate.filter.reset")}
      </span>
    </div>

    {/* Sort Field */}
    <div
      style={{
        background: "white",
        border: "1px solid #eee",
        borderRadius: "10px",
        padding: "12px",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
      }}
    >
      <label style={{ fontWeight: "600", fontSize: "14px", color: "#333" }}>
        {t("MyCCOPro.SearchCandidate.field")}
      </label>
      <select
        value={filters.SortBy}
        onChange={(e) => dispatch(setSortBy(Number(e.target.value)))}
        style={{
          padding: "8px 10px",
          fontSize: "14px",
          border: "1px solid #ddd",
          borderRadius: "6px",
          outline: "none",
        }}
      >
        <option value={0}>{t("MyCCOPro.SearchCandidate.name")}</option>
        <option value={1}>{t("MyCCOPro.SearchCandidate.ccoid")}</option>
      </select>
    </div>


  <button
  onClick={() =>{ 
    // setTempOrder(tempOrder === "asc" ? "desc" : "asc")
    dispatch(setOrderBy(filters.OrderBy==0?1:0))
  }}
  style={{
    padding: "7px 12px",
    fontSize: "14px",
    border: "2px solid #ccc",
    borderRadius: "6px",
    backgroundColor: "#f7f7f7",
    cursor: "pointer",
  }}
>
  {filters.OrderBy === 0
    ? t('MyCCOPro.SearchCandidate.ascending')
    : t('MyCCOPro.SearchCandidate.descending')}
</button>


    {/* Apply Button */}
    <button
      onClick={handleApplySort}
      style={{
        padding: "12px",
        backgroundColor: "#c67b05",
        color: "white",
        border: "none",
        borderRadius: "20px",
        fontWeight: "600",
        cursor: "pointer",
        marginTop: "10px",
      }}
    >
      {t("MyCCOPro.SearchCandidate.apply")}
    </button>
  </div>
)}

    
    </div>
    </div>
  </div>
</div>
  <div className="cco_col">
     <div className="cco_row cco_row_38">
  <div className="cco_col">
    {loading ? (
               <div className="cco_row cco_row_3"style={{ marginTop: '60px' }} >
                    <Loader />
                  </div>
    ) : fetchError ? (
      <p style={{ color: "red", marginTop: "10px" , marginBottom: "10px" , textAlign: "center" }}>{fetchError}</p>
    ) : connectionList && connectionList.length > 0 ? (
<div className="cco_group cco_group_myCredential">
  {viewMode === "grid" ? (
    connectionList.map((item, index) => (
      <MyConnectionCard
        key={item.CertWatchRequestId}
        connection={item}
        index={index}
      />
    ))
  ) : (
    <MyConnectionListView connections={connectionList} />
  )}
</div>


    ) : (
      <p style={{ marginTop: "10px" , marginBottom: "10px" , textAlign: "center" }}>{searchTerm? `No connections found for ${searchTerm}`: "No connections found"}</p>
    )}
  </div>
</div>



 <div
  style={{
    marginTop: "24px",
    display: "flex",
    justifyContent: "flex-end", 
    alignItems: "center",
    gap: "16px",
    fontFamily: "Inter, sans-serif",
    fontSize: "14px",
    color: "#444",
    flexWrap: "wrap", 
  }}
>

  <div style={{ display: "flex",justifyContent: "end", alignItems: "center", gap: "6px" }}>
    <span style={{ color: "#666" }}>                
      {t("MyCCOPro.SearchCandidate.recordsperpage")}
</span>
    <select
      value={pageSize}
      onChange={(e) => {
        
        dispatch(setPageSize(Number(e.target.value)));
        dispatch(setPage(1))
        handleGlobalClick();
 
      }}
      style={{
        padding: "6px 12px",
        borderRadius: "6px",
        border: "1px solid #ddd",
        fontSize: "14px",
        fontWeight: "500",
        cursor: "pointer",
        color: "#333",
        outline: "none",
        background: "#fff",
      }}
    >
      <option value={25}>25</option>
      <option value={50}>50</option>
      <option value={100}>100</option>
    </select>
  </div>

 
  <div
    style={{
      display: "flex",
      flexWrap: "wrap", 
      justifyContent: "flex-end",
      alignItems: "center",
      gap: "6px",
    }}
  >

    {page > 1 && (
    <><button
                            disabled={page === 1}
                            onClick={() => {
 dispatch(setPage(1))
        handleGlobalClick();
                          }}
                            style={{
                              padding: "6px 10px",
                              borderRadius: "6px",
                              border: "1px solid #c67b05",
                              color: "#c67b05",
                              fontWeight: "600",
                              backgroundColor: "white",
                              cursor: page === 1 ? "not-allowed" : "pointer",
                            }}
                          >
                            {"<<"}
                          </button><button
                            disabled={page === 1}
                            onClick={() =>{
                        
                               dispatch(setPage(page-1))
        handleGlobalClick();
                            }}
                            style={{
                              padding: "6px 10px",
                              borderRadius: "6px",
                              border: "1px solid #c67b05",
                              color: "#c67b05",
                              fontWeight: "600",
                              backgroundColor: "white",
                              cursor: page === 1 ? "not-allowed" : "pointer",
                            }}
                          >
                              {"<"}
                            </button></>
    )}


    {(() => {
      const totalPages = Math.ceil(totalCount / pageSize);
      const delta = window.innerWidth < 600 ? 1 : 2; 
      const range: (number | string)[] = [];
      let last: number | undefined;

      for (let i = 1; i <= totalPages; i++) {
        if (
          i === 1 ||
          i === totalPages ||
          (i >= page - delta && i <= page + delta)
        ) {
          if (last && i - last > 1) {
            range.push("...");
          }
          range.push(i);
          last = i;
        }
      }

      return range.map((page1, idx) => (
        <button
          key={idx}
          onClick={() =>{
             typeof page === "number" && dispatch(setPage(Number(page1)))
             handleGlobalClick();
          }}
          disabled={page1 === "..."}
          style={{
            padding: "6px 12px",
            borderRadius: "6px",
            border: "1px solid #c67b05",
            backgroundColor: page1 === page ? "#c67b05" : "#fff",
            color: page1 === page ? "#fff" : "#c67b05",
            fontWeight: "600",
            cursor: page1 === "..." ? "default" : "pointer",
            opacity: page1 === "..." ? 0.6 : 1,
          }}
        >
          {page1}
        </button>
      ));
    })()}

    {page < totalPages && (
    <><button
                            disabled={page >= Math.ceil(totalCount / pageSize)}
                            onClick={() =>{
                               dispatch(setPage(1+1))
        handleGlobalClick();
                            } }
                            style={{
                              padding: "6px 10px",
                              borderRadius: "6px",
                              border: "1px solid #c67b05",
                              color: "#c67b05",
                              fontWeight: "600",
                              backgroundColor: "white",
                              cursor: page >= Math.ceil(totalCount / pageSize)
                                ? "not-allowed"
                                : "pointer",
                            }}
                          >
                            {">"}
                          </button><button
                            disabled={page >= Math.ceil(totalCount / pageSize)}
                            onClick={() =>{
                             dispatch(setPage(Math.ceil(totalCount / pageSize)));
                            handleGlobalClick();
                            }}
                            style={{
                              padding: "6px 10px",
                              borderRadius: "6px",
                              border: "1px solid #c67b05",
                              color: "#c67b05",
                              fontWeight: "600",
                              backgroundColor: "white",
                              cursor: page >= Math.ceil(totalCount / pageSize)
                                ? "not-allowed"
                                : "pointer",
                            }}
                          >
                              {">>"}
                            </button></>
    )}
  </div>
</div> 



</div>

</div>

 </>
 {/* )} */}


{editCertConnectModal && (
<Modal
  isOpen={true}
onRequestClose={() => dispatch(closeModal("editCertConnectModal"))}
  shouldCloseOnOverlayClick={false}
  contentLabel="Edit Note and Availability"
  style={{
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1001,
    },
    content: {
      position: 'relative',
      width: '480px',
      maxWidth: '95%',
      padding: '30px',
      borderRadius: '12px',
      inset: 'unset',
      backgroundColor: '#ffffff',
      boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
      border: 'none',
      fontFamily: 'Segoe UI, sans-serif',
    },
  }}
>
  {/* Header */}
  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    <h2 style={{ margin: 0, fontSize: '20px', fontWeight: 600, color: '#222' }}>
     {t('MyCCOPro.SearchCandidate.editNoteAvailability')}
    </h2>
    <button
      onClick={()=>dispatch(closeModal("editCertConnectModal"))}
      style={{
        background: 'transparent',
        border: 'none',
        fontSize: '22px',
        fontWeight: 'bold',
        cursor: 'pointer',
        color: '#888',
        lineHeight: 1,
      }}
      aria-label="Close modal"
    >
      ×
    </button>
  </div>

  {/* Body */}
  <div style={{ marginTop: '24px' }}>
    <div style={{ marginBottom: '20px' }}>
      <label style={{ fontSize: '15px', fontWeight: '500', color: '#444' }}>
        <input
          type="checkbox"
          checked={editConnectionForm.available}
          onChange={(e) => setEditConnectionForm({ ...editConnectionForm, available: e.target.checked })}
          style={{ marginRight: '10px', transform: 'scale(1.2)' }}
        />
       {t('MyCCOPro.SearchCandidate.available')}
      </label>
    </div>

    <div>
      <label style={{ fontSize: '15px', fontWeight: '500', color: '#444', display: 'block' }}>
         {t('MyCCOPro.SearchCandidate.note')}
      </label>
      <textarea
        value={editConnectionForm.note}
        onChange={(e) => setEditConnectionForm({ ...editConnectionForm, note: e.target.value })}
        style={{
          width: '100%',
          minHeight: '110px',
          marginTop: '8px',
          padding: '12px',
          borderRadius: '8px',
          border: '1px solid #ccc',
          fontSize: '14px',
          lineHeight: '1.5',
          resize: 'vertical',
        }}
      />
    </div>
  </div>

  {/* Footer */}
  <div
    style={{
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: '28px',
      gap: '12px',
    }}
  >
    <button
      onClick={()=>dispatch(closeModal("editCertConnectModal"))}
      style={{
        padding: '10px 18px',
        backgroundColor: '#f3f3f3',
        color: '#333',
        border: '1px solid #ddd',
        borderRadius: '6px',
        cursor: 'pointer',
        fontWeight: 500,
      }}
    >
      {t('MyCCOPro.SearchCandidate.cancel')}
    </button>
    <button
      onClick={handleSave}
      disabled={editLoading}
      style={{
        padding: '10px 18px',
        backgroundColor: editLoading? '#b57a28' : '#c67b05',
        color: 'white',
        border: 'none',
        borderRadius: '6px',
        cursor: editLoading ? 'not-allowed' : 'pointer',
        fontWeight: 500,
        minWidth: '90px',
      }}
    >
       {editLoading ? t('MyCCOPro.SearchCandidate.saving') : t('MyCCOPro.SearchCandidate.save')}
    </button>
  </div>
</Modal>  
)}


{requestAccessModal && (
    <Modal
        isOpen={true}
        onRequestClose={dispatch(openModal("requestAccessModal"))}
        shouldCloseOnOverlayClick={false}
        contentLabel="Action Confirmation"
        style={{
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0 20px',
          },
          content: {
            position: 'relative',
            width: '400px',
            padding: '20px',
            borderRadius: '8px',
            inset: 'unset',
            backgroundColor: 'white',
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
            textAlign: 'center',
          },
        }}
      >
        <h1 style={{ marginBottom: '15px' }}>   {t('MyCCOPro.SearchCandidate.actionComplete')}</h1>

        <p style={{ marginBottom: '15px' }}>
          <img src={logo} alt="Checkmark" style={{ width: '80px', height: '80px' }} />
        </p>

        <p>{t('MyCCOPro.SearchCandidate.modalerror')}</p>

        <button
          onClick={() =>dispatch(closeModal("requestAccessModal"))}  
          style={{
            paddingLeft: '10px',
            paddingRight: '10px',
            backgroundColor: '#c67b05',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            marginTop :'20px'
          }}
        >
       {t('MyCCOPro.SearchCandidate.ok')}
        </button>
</Modal>
)}


{connectionModal && (
<Modal
  isOpen={true}
  onRequestClose={()=>dispatch(openModal("connectionModal"))}
  shouldCloseOnOverlayClick={false}
  contentLabel="Candidate Detail"
  style={{
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 201,

    },
    content: {
      position: 'relative',
      width: '90%', 
      maxWidth: '1200px', 
      height: 'auto',
      maxHeight: '90vh',
      overflowY: 'auto',
      padding: '30px',
      borderRadius: '12px',
      inset: 'unset',
      backgroundColor: '#ffffff',
      boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
      border: 'none',
      fontFamily: 'Segoe UI, sans-serif',
    },
  }}
>

  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: "20px" }}>
    <h2 style={{ margin: 0, fontSize: '20px', fontWeight: 600, color: '#222' }}>
      {connection?.ContactName}
    </h2>
    <button
      onClick={() => dispatch(closeModal("connectionModal"))}
      style={{
        background: 'transparent',
        border: 'none',
        fontSize: '22px',
        fontWeight: 'bold',
        cursor: 'pointer',
        color: '#888',
        lineHeight: 1,
      }}
      aria-label="Close modal"
    >
      ×
    </button>
  </div>


  <div className="cco_accordion_item_body" style={{ display: 'block' }}>
    <div>
      <table className="cco_table cco_table_1">
        <tbody className="cco_table_body">
          <tr className="cco_table_row">
       
            <td className="cco_table_cell cco_table_cell_small">
              {connection?.ContactProfilePic ? (
                <img
                  src={connection?.ContactProfilePic}
                  alt="Profile"
                  style={{
                    width: '90px',
                    height: '90px',
                    borderRadius: '50%',
                    objectFit: 'cover',
                  }}
                />
              ) : (
                <img
                  src={iconImage}
                  alt="Profile"
                  style={{
                    width: '90px',
                    height: '90px',
                    borderRadius: '50%',
                    objectFit: 'cover',
                    color:'red'
                  }}
                />
              )}
            </td>

            {/* Main details */}
            <td className="cco_table_cell cco_table_cell_medium">
              {/* Name */}
              <div className="cco_blurb cco_blurb_0">
                <div className="cco_blurb_label">{t('MyCCOPro.SearchCandidate.name')}</div>
                <div className="cco_blurb_value">
                  <strong>{connection?.ContactName}</strong>
                </div>
              </div>

              {/* CCO ID */}
              <div className="cco_blurb cco_blurb_0">
                <div className="cco_blurb_label">{t('MyCCOPro.SearchCandidate.ccoId')}</div>
                <div className="cco_blurb_value">
                  <strong>{connection?.ContactCCOID || '—'}</strong>
                </div>
              </div>

              {/* Conditional contact info */}
              {connection?.StatusReason === 'Pending' ||
              connection?.CandidateAccessControl === 'Locked' || connection?.IsPhotoApproved === false ||
              connection?.ShowContactInfo === false ? null : (
                <>
                  <div className="cco_blurb cco_blurb_0">
                    <div className="cco_blurb_label">{t('MyCCOPro.SearchCandidate.email')}</div>
                    <div className="cco_blurb_value">
                      <strong>{connection?.ContactEmail}</strong>
                    </div>
                  </div>

                  <div className="cco_blurb cco_blurb_0">
                    <div className="cco_blurb_label">{t('MyCCOPro.SearchCandidate.mobile')}</div>
                    <div className="cco_blurb_value">
                      <strong>{connection?.ContactMobilePhone || '—'}</strong>
                    </div>
                  </div>

                  {/* Availability */}
                  <div className="cco_blurb cco_blurb_0">
                    <div className="cco_blurb_label">{t('MyCCOPro.SearchCandidate.available')}</div>
                    <div className="cco_blurb_value">
                      {connection?.Available ? (
                        <img
                          src={check}
                          alt="Available"
                          style={{ width: '25px', height: '25px' }}
                        />
                      ) : (
                        <img
                          src={checkbox}
                          alt="Not Available"
                          style={{ width: '21px', height: '21px' }}
                        />
                      )}
                    </div>
                  </div>

                  {/* Note */}
                  <div className="cco_blurb cco_blurb_0">
                    <div className="cco_blurb_label">{t('MyCCOPro.SearchCandidate.note')}</div>
                    <div className="cco_blurb_value">
                      <strong>{connection?.Note || '—'}</strong>
                    </div>
                  </div>
                </>
              )}
            </td>

            {/* Right column -> designation/status */}
        <td
  className="cco_table_cell cco_table_cell_small"
  style={{ verticalAlign: "top" }}
>
  {/* 🔒 Account Locked */}
  {connection?.StatusReason === "Approved" &&
  connection?.CandidateAccessControl === "Locked" ? (
    <div
      style={{
        marginTop: "10px",
        fontWeight: "bold",
        color: "#c53030",
        marginLeft: "-40px",
      }}
    >
      {t("MyCCOPro.SearchCandidate.accounterror")}
    </div>
  ) : /* 🟡 Pending */ connection?.StatusReason === "Pending" ? (
    <div
      style={{
        marginTop: "10px",
        fontWeight: "bold",
        color: "#c67b05",
      }}
    >
      {t("MyCCOPro.SearchCandidate.pendingError")}
    </div>
  ) : /* 🚫 Approved but Photo NOT Approved */ connection?.StatusReason ===
      "Approved" &&
    connection?.CandidateAccessControl !== "Locked" &&
    connection?.IsPhotoApproved === false ? (
    <div
      style={{
        marginTop: "10px",
        fontWeight: "bold",
        color: "#c67b05",
        textAlign: "center",
      }}
    >
      {t("MyCCOPro.SearchCandidate.IsApprovedPhotoError")}
    </div>
  ) : (
    /* ✅ Approved + Photo Approved + Not Locked → Show Certifications */
    <>
      <div
        style={{
          marginTop: "10px",
          fontWeight: "bold",
          display: "flex",
          justifyContent: "space-between",
          gap: "10px",
        }}
      >
        <span style={{ flex: 1, textAlign: "left" }}>
          {t("MyCCOPro.SearchCandidate.designation")}
        </span>
        <span style={{ flex: 1, textAlign: "center" }}>
          {t("MyCCOPro.SearchCandidate.status")}
        </span>
        <span style={{ flex: 1, textAlign: "right" }}>
          {t("MyCCOPro.SearchCandidate.expiration")}
        </span>
      </div>

      {contactDesigLoading ? (
        <p>
          <Loader />
        </p>
      ) : contactDesigError ? (
        <p style={{ color: "red" }}>{contactDesigError}</p>
      ) : Array.isArray(contactDesignations) &&
        contactDesignations.length > 0 ? (
        [...contactDesignations]
          .sort((a, b) => a.Code.localeCompare(b.Code))
          .map((designator, i) => {
            const expirationDate = designator.CertExpirationDate
              ? designator.CertExpirationDate.split("T")[0]
              : "—";

            const today = new Date();
            const expiry = designator.CertExpirationDate
              ? new Date(designator.CertExpirationDate)
              : null;

            const oneYearFromToday = new Date();
            oneYearFromToday.setFullYear(today.getFullYear() + 1);

            const isExpiringSoon =
              expiry !== null ? expiry <= oneYearFromToday : false;

            const expirationStyle = isExpiringSoon
              ? { color: "red", fontWeight: "bold" }
              : {};

            return (
              <div
                key={i}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "10px",
                  marginTop: "4px",
                  alignItems: "center",
                  whiteSpace: "nowrap",
                }}
              >
                <span style={{ flex: 1 }}>{designator.Code}</span>
                <span style={{ flex: 1, textAlign: "center" }}>
                  {/* {designator.Status} */}
                  {t(`MyCCOPro.SearchCandidate.Statuses.${designator.Status}`, { defaultValue: designator.Status })}

                </span>
                <span
                  style={{
                    flex: 1,
                    textAlign: "right",
                    ...expirationStyle,
                  }}
                >
                  {expirationDate}
                </span>
              </div>
            );
          })
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "8px",
            marginTop: "4px",
          }}
        >
          <span>N/A</span>
          <span>N/A</span>
          <span>N/A</span>
        </div>
      )}
    </>
  )}
</td>

          </tr>
        </tbody>
      </table>

      {/* Footer menu */}
      <ul className="cco_menu cco_menu_3">
         {connection?.StatusReason === 'Pending' || connection?.IsPhotoApproved === false || connection?.CandidateAccessControl === 'Locked'  ? null : ( 
          <li className="cco_menu_item">
            <Link
              to="#"
              onClick={async () => {
                 setEditConnectionForm({
                   note: connection?.Note || '',
                   available: connection?.Available || false,
                 });
               dispatch(openModal("editCertConnectModal"));

              }}
              style={{ cursor: 'pointer', textDecoration: 'none' }}
            >
              {t('MyCCOPro.SearchCandidate.edit')}
            </Link>
          </li>
         )} 
        <li className="cco_menu_item">
          <Link
            to="#"
            onClick={(e) => {
              e.preventDefault();
      
              handleRemove(connection?.CertWatchRequestId, contactId);
             dispatch(closeModal("connectionModal"));

            }}
            style={{ cursor: 'pointer', textDecoration: 'none' }}
          >
            {t('MyCCOPro.SearchCandidate.remove')}
          </Link>
        </li>
        {connection?.ShowSharebutton === true &&
        connection?.StatusReason === 'Approved' && connection?.IsPhotoApproved !== false &&
        connection?.CandidateAccessControl !== 'Locked' &&
        connection?.MyCCODesignationDetails?.length !== 0 ? (
          <ShareModal CCOID={connection?.ContactCCOID} Name={connection?.ContactName} />
        ) : null}
      </ul>
    </div>
  </div>

</Modal>  
)}





    
    </div>
  );
};






